import React from "react";
import { Star } from "lucide-react";
import {
  Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious,
} from "@/components/ui/carousel";
import { VideoCard } from "@/components/VideoCard";

export const FeaturedCarousel = ({ videos, whatsapp, price, currency }) => {
  if (!videos || videos.length === 0) return null;

  return (
    <section
      data-testid="featured-carousel"
      className="relative overflow-hidden bg-gradient-to-b from-[#160a12] to-[#120E0C] py-16 sm:py-20"
    >
      <div className="absolute -top-24 left-1/4 h-72 w-72 rounded-full bg-amber-500/15 blur-3xl" />
      <div className="absolute -bottom-24 right-1/4 h-72 w-72 rounded-full bg-rose-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-2 text-amber-300">
          <Star className="h-4 w-4 fill-current" />
          <span className="text-xs tracking-widest uppercase font-semibold">Spotlight</span>
          <Star className="h-4 w-4 fill-current" />
        </div>
        <h2 className="mt-2 text-center font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-50">
          Featured <span className="festive-text">Invites</span>
        </h2>
        <p className="mt-3 text-center text-stone-300/80">A handpicked selection of our most-loved designs.</p>

        <Carousel opts={{ align: "start", loop: videos.length > 3 }} className="mt-12">
          <CarouselContent className="-ml-4">
            {videos.map((v, i) => (
              <CarouselItem key={v.id} className="pl-4 sm:basis-1/2 lg:basis-1/3">
                <div className="relative">
                  <span className="absolute -top-2 -left-2 z-20 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide bg-gradient-to-r from-amber-400 to-amber-600 text-white shadow-lg">
                    <Star className="h-3 w-3 fill-current" /> Featured
                  </span>
                  <VideoCard video={v} whatsappNumber={whatsapp} price={price} currency={currency} index={i} />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious data-testid="featured-prev" className="hidden sm:flex -left-4 bg-white/90 border-amber-300 text-amber-900 hover:bg-white" />
          <CarouselNext data-testid="featured-next" className="hidden sm:flex -right-4 bg-white/90 border-amber-300 text-amber-900 hover:bg-white" />
        </Carousel>
      </div>
    </section>
  );
};
